if (!customElements.get('copy-code-button')) {
    customElements.define('copy-code-button', class CopyCodeButton extends HTMLElement {
      constructor() {
        super();
        this.button = this;
        this.code = this.dataset.codeToCopy;
        this.copyIcon = this.querySelector('.copy-icon');
        this.checkIcon = this.querySelector('.check-icon');

        this.addEventListener('click', this.onCopy.bind(this));
      }

      onCopy() {
        if (!navigator.clipboard) return;

        navigator.clipboard.writeText(this.code).then(() => {
          this.copyIcon.hidden = true;
          this.checkIcon.hidden = false;
          
          // Revert back after 2 seconds
          setTimeout(() => {
            this.copyIcon.hidden = false;
            this.checkIcon.hidden = true;
          }, 2000);
        }).catch(err => {
          console.error('Failed to copy code: ', err);
        });
      }
    });
  }

  /*
  ============================================================
  1. CART COUNTDOWN TIMER
  ============================================================
  */
 /*  (function() {
    const timerElement = document.getElementById('cart-countdown');
    const timerBanner = document.getElementById('cart-timer-banner');
    if (!timerElement || !timerBanner) return;

    const cartItemCount = parseInt(timerBanner.dataset.cartEmpty, 10);
    const storageKey = 'cartExpiryTimestamp';
    const expiryMinutes = 15;
    
    // 1. Check if we need to set a new timer
    if (cartItemCount > 0 && !localStorage.getItem(storageKey)) {
      const newExpiry = Date.now() + expiryMinutes * 60 * 1000;
      localStorage.setItem(storageKey, newExpiry);
    } else if (cartItemCount === 0) {
      localStorage.removeItem(storageKey);
      return; // No timer to run
    }

    // 2. Start the timer
    const expiryTimestamp = parseInt(localStorage.getItem(storageKey), 10);
    
    function updateTimer() {
      const remaining = expiryTimestamp - Date.now();
      
      if (remaining <= 0) {
        // Timer expired!
        timerElement.textContent = "00:00";
        clearInterval(timerInterval);
        
        // Optional: Clear the cart
        // fetch('/cart/clear.js', { method: 'POST' })
        //   .then(() => window.location.reload());
        return;
      }
      
      const minutes = Math.floor((remaining / 1000 / 60) % 60).toString().padStart(2, '0');
      const seconds = Math.floor((remaining / 1000) % 60).toString().padStart(2, '0');
      
      timerElement.textContent = `${minutes}:${seconds}`;
    }

    const timerInterval = setInterval(updateTimer, 1000);
    updateTimer(); // Run once immediately
  })(); */


//   -----------------------------------------------------------
// 2. CART DRAWER UPSELL SHEET
//   -----------------------------------------------------------

if (!customElements.get('upsell-product-sheet')) {
  customElements.define('upsell-product-sheet', class UpsellProductSheet extends HTMLElement {
    constructor() {
      super();
      this.sheet = document.getElementById('UpsellSheet');
      this.body = document.body;
      
      // We bind to the cart-drawer element
      this.cartDrawer = document.querySelector('cart-drawer');

      // Use event delegation for click
      this.cartDrawer.addEventListener('click', this.onOpenerClick.bind(this));
      
      // Clicks for closing
      this.sheet.addEventListener('click', (event) => {
        if (event.target.dataset.action === 'close') {
          this.close();
        }
      });
      
      // Close on 'Add to Cart' success
      // This listens for the 'product-form:added' event dispatched by Dawn's 'product-form.js'
      this.sheet.querySelector('product-form').addEventListener('product-form:added', () => {
        this.close();
      });
    }

    onOpenerClick(event) {
      const opener = event.target.closest('.cart-upsell-opener');
      if (!opener) return; // Click wasn't on an opener

      event.preventDefault();
      const productHandle = opener.dataset.productHandle;

      // Find the price in the button to pass to the sheet
      // This is more reliable than re-calculating
      const price = opener.querySelector('.cart-upsell-item__price')?.textContent;
      const originalPrice = opener.querySelector('.cart-upsell-item__old-price')?.textContent;

      this.open(productHandle, { price, originalPrice });
    }

    open(productHandle, priceData) {
      this.body.classList.add('overflow-hidden');
      this.sheet.setAttribute('aria-hidden', 'false');
      
      // Set loading state
      this.sheet.classList.add('is-loading');

      // Fetch product data
      fetch(`/products/${productHandle}.js`)
        .then(response => response.json())
        .then(product => {
          this.renderProduct(product, priceData);
          this.sheet.classList.remove('is-loading');
        })
        .catch(e => {
          console.error(e);
          this.sheet.classList.remove('is-loading');
          // You could show an error here
        });
    }

    renderProduct(product, priceData) {
      const firstVariant = product.variants[0];

      // 1. Header
      document.getElementById('UpsellSheet-Title').textContent = product.title;
      const variantSizeEl = document.getElementById('UpsellSheet-Size');
      if (firstVariant.title && firstVariant.title !== 'Default Title') {
        variantSizeEl.textContent = `(${firstVariant.title})`;
        variantSizeEl.hidden = false;
      } else {
        variantSizeEl.hidden = true;
      }

      // 2. Body: Images (simple carousel)
      const imagesEl = document.getElementById('UpsellSheet-Images');
      imagesEl.innerHTML = ''; // Clear old images
      product.images.forEach(image => {
        const img = document.createElement('img');
        img.src = image.src;
        img.alt = image.alt || product.title;
        img.className = 'upsell-sheet__image';
        img.width = image.width;
        img.height = image.height;
        img.loading = 'lazy';
        imagesEl.appendChild(img);
      });

      // 3. Body: Description
      document.getElementById('UpsellSheet-Description').innerHTML = product.description;

      // 4. Body: Price (from the data we passed)
      const priceContainer = document.getElementById('UpsellSheet-Price');
      priceContainer.querySelector('.price-current').textContent = priceData.price;
      const originalPriceEl = priceContainer.querySelector('.price-original');
      if (priceData.originalPrice) {
        originalPriceEl.textContent = priceData.originalPrice;
        originalPriceEl.hidden = false;
      } else {
        originalPriceEl.hidden = true;
      }
      
      // 5. Footer: Update Product Form
      document.getElementById('UpsellSheet-VariantId').value = firstVariant.id;
      
      const addButton = document.getElementById('UpsellSheet-AddButton');
      const addText = `Add for ${priceData.price}`;
      // Check if item is already in cart
      // We can't use the 'is_added' from Liquid, so we check the global 'cart' object
      // This requires your cart data to be accessible, or just check the DOM
      let isAdded = false;
      document.querySelectorAll('.cart-item-grouped').forEach(item => {
        if (item.dataset.productId == product.id) {
          isAdded = true;
        }
      });
      
      if (isAdded) {
        addButton.textContent = 'Added';
        addButton.disabled = true;
      } else {
        addButton.textContent = addText;
        addButton.disabled = false;
      }
    }

    close() {
      this.body.classList.remove('overflow-hidden');
      this.sheet.setAttribute('aria-hidden', 'true');
    }
  });
  
  // Initialize the sheet component
  // new UpsellProductSheet();
}

// -----------------------------------------------------------
// 3. Discrete Packaging Checkbox
// -----------------------------------------------------------
document.addEventListener('DOMContentLoaded', () => {
  const checkbox = document.getElementById('discrete-packing');
  if (!checkbox) {
    return;
  }

  const fieldWrapper = checkbox.closest('.cart-attribute-field');

  checkbox.addEventListener('change', () => {
    // Get the value to send
    const value = checkbox.checked ? 'Yes' : 'No';
    
    // Show loading spinner
    if (fieldWrapper) {
      fieldWrapper.classList.add('is-loading');
    }

    // Prepare the data
    const body = JSON.stringify({
      attributes: {
        'Discrete Packaging': value
      }
    });

    // Send the AJAX request to update the cart
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: body
    })
    .then(response => response.json())
    .then(cart => {
      console.log('Cart attributes updated:', cart.attributes);
      // Optional: You could dispatch an event here if other
      // parts of your theme need to know the cart updated.
      //
      // if (typeof publish === 'function' && typeof PUB_SUB_EVENTS === 'object') {
      //   publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-attributes', cartData: cart });
      // }
    })
    .catch((e) => {
      console.error('Failed to update cart attributes:', e);
    })
    .finally(() => {
      // Hide loading spinner
      if (fieldWrapper) {
        fieldWrapper.classList.remove('is-loading');
      }
    });
  });
});
